export const getAmeaData = async (category) => {
  const response = await fetch(
    "https://amea-ampel-cms.dotsoft.gr/api/el/routes-infrastructures",
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching infrastructures:", error));
  if (response) {
    return category === "infra" ? response.infrastructures : response.routes;
  }
  return [];
};

export const getAllAmeaData = async () => {
  const response = await fetch(
    "https://amea-ampel-cms.dotsoft.gr/api/el/routes-infrastructures",
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching infrastructures:", error));
  if (response) {
    return response;
  }
  return {};
};

export const getEnvironmentalData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=envi&lang=${lang}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Environmental Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getAverageEnvironmentalData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=envi_daily_average`,
    // `https://zakynthos.smartiscity.gr/api/api.php?func=envi&lang=${lang}`
  )
    .then((response) => {
      return response;
    })
    .catch((error) => console.log("Error fetching Environmental Data:", error));
  if (response) {
    return response.json();
  }
  return [];
};

export const getEnergyData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://panel.ianosenergy.gr/api/api.php?func=smart&region=12`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Energy Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getHumData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=ham&lang=${lang}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Hum Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getHydroData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=waterq&lang=${lang}`,
    {
      method: "GET",
      redirect: "follow",
    },
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Hydro Data:", error));

  if (response) {
    return response;
  }
  return [];
};

export const getFleetData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=fleeto&lang=${lang}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Fleet Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getHotSpotsData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://skoufas.smartiscity.gr/api/api.php?func=hotspot&lang=${lang}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching HotSpots Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getBinsData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=bins&lang=${lang}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Bins Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getParkingData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=parking&lang=${lang}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Parking Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getParkingDetails = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=parkingAll&lang=${lang}`,
  )
    .then((response) => {
      return response;
    })
    .catch((error) =>
      console.log("Error fetching Parking Details Data:", error),
    );
  if (response) {
    return response.json();
  }
  return [];
};

export const getPublicParkingData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=publicparking&lang=${lang}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Parking Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getPublicParkingDetails = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=publicparkingAll&lang=${lang}`,
  )
    .then((response) => {
      return response;
    })
    .catch((error) =>
      console.log("Error fetching Parking Details Data:", error),
    );
  if (response) {
    return response.json();
  }
  return [];
};

export const getBinData = async ({ binId }) => {
  const response = await fetch(
    `https://skoufas.smartiscity.gr//api/api.php?func=binstats&id=${binId}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Bins Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getHydroStatsData = async ({ binId }) => {
  const response = await fetch(
    `https://demokritos.smartiscity.gr/api/api.php?func=hydrostats&id=${binId}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Bins Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getMeteoInfoData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=meteo&lang=${lang}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Meteo Info Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getMeshData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=mesh&lang=${lang}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Mesh Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getWeatherData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=forecast&lang=${lang}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Weather Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getIndexesData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=indexes&lang=${lang}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Indexes Info Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getAllSensorsData = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=allsensors&lang=${lang}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching All Sensors Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getMoreAllSensors = async () => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=allsensors&lang=el`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching All Sensors Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getSensorTypes = async ({ lang = "el" }) => {
  const response = await fetch(
    `https://zakynthos.smartiscity.gr/api/api.php?func=sensortypes&lang=${lang}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Sensors Types Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getRoutesCategories = async ({ lang = "el" }) => {
  const response = await fetch(
    `${process.env.REACT_APP_BASE_URL}/api/routes/categories`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("Error fetching Sensors Types Data:", error));
  if (response) {
    return response;
  }
  return [];
};

export const getMobilityData = async (date) => {
  const response = await fetch(
    `https://zakynthos.dotsoft.gr/api/exchange/datasets/traffic-conditions?from=${date}`,

    {
      headers: {
        Host: "services.invipo.local",
        "User-Agent":
          "Mozilla/5.0 (Windows; U; Windows NT 6.1; en-US; rv:1.0.1.5)",
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: process.env.REACT_APP_INVIPO_API_KEY,
      },
    },
  )
    .then((response) => {
      return response.json();
    })
    .catch((data) => {
      console.log(JSON.stringify(data));
      return [];
    });

  return response;
};

export const getLocationData = async (lat, lng) => {
  const data = await fetch(
    `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`,
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log("Error fetching location data:", error);
      return {};
    });
  return data;
};

export const getTokens = async (code) => {
  const isDEV = window.location.href.includes("localhost");

  const tokens = await fetch(`${process.env.REACT_APP_BASE_URL}/oauth/token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      client_id: isDEV
        ? process.env.REACT_APP_DEV_CLIENT_ID
        : process.env.REACT_APP_PROD_CLIENT_ID,
      client_secret: isDEV
        ? process.env.REACT_APP_DEV_CLIENT_SECRET
        : process.env.REACT_APP_PROD_CLIENT_SECRET,
      redirect_uri: isDEV
        ? process.env.REACT_APP_DEV_REDIRECT_URI
        : process.env.REACT_APP_PROD_REDIRECT_URI,
      code,
      scope: "citizen",
      grant_type: "authorization_code",
    }),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log("Error fetching tokens:", error);
      return null;
    });

  return tokens;
};

export const refreshToken = async (refreshToken) => {
  const isDEV = window.location.href.includes("localhost");
  const newTokens = await fetch(
    `${process.env.REACT_APP_BASE_URL}/oauth/token`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        refresh_token: refreshToken,
        client_id: isDEV
          ? process.env.REACT_APP_DEV_CLIENT_ID
          : process.env.REACT_APP_PROD_CLIENT_ID,
        client_secret: isDEV
          ? process.env.REACT_APP_DEV_CLIENT_SECRET
          : process.env.REACT_APP_PROD_CLIENT_SECRET,
        grant_type: "refresh_token",
      }),
    },
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log("Error Refreshing tokens", error);
      return null;
    });
  return newTokens;
};

export const handleRegistration = async ({
  firstName,
  lastName,
  email,
  password,
  address,
}) => {
  const registerUser = await fetch(
    `${process.env.REACT_APP_BASE_URL}/api/users/register`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        first_name: firstName,
        last_name: lastName,
        email,
        password,
        address,
      }),
    },
  )
    .then((response) => {
      if (response) {
        return response.json();
      }
    })
    .catch((error) => {
      console.log("Error registering user:", error);
      return null;
    });

  return registerUser;
};

export const getUser = async (token) => {
  const user = await fetch(`${process.env.REACT_APP_BASE_URL}/api/users/get`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (response) {
        return response.json();
      }
    })
    .catch((error) => {
      console.log("Error Refreshing tokens", error);
      return null;
    });
  return user;
};

export const logoutUser = async (token) => {
  const logout = await fetch(
    `${process.env.REACT_APP_BASE_URL}/api/users/logout`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log("Error logging out user:", error);
      return null;
    });
  return logout;
};

export const userUpdate = async (body, token) => {
  const user = await fetch(`https://amea-ampel-cms.dotsoft.gr/api/users/edit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...body,
    }),
    redirect: "follow",
  })
    .then((response) => {
      if (response) {
        return response.json();
      }
    })
    .catch((error) => {
      console.log("Error updating user:", error);
      return null;
    });
  return user;
};

export const createNewRoute = async (body, token) => {
  const newRoute = await fetch(`${process.env.REACT_APP_BASE_URL}/api/routes`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...body,
    }),
    redirect: "follow",
  })
    .then((response) => {
      if (response) {
        return response.json();
      }
    })
    .catch((error) => {
      console.log("Error creating new route:", error);
      return null;
    });
  return newRoute;
};
